import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PromotionFeatureFlagKeys, PromotionFeatureFlagsDTO } from './promotion-feature-flags.model';
import { catchError, Observable, of, tap } from 'rxjs';
import { isDefined } from '../../components/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class PromotionFeatureFlagsService {
  private promotionFeatureFlags: PromotionFeatureFlagsDTO = undefined;

  constructor(private http: HttpClient) {}

  getPromotionFeatureFlags(): Observable<PromotionFeatureFlagsDTO> {
    return this.http.get<PromotionFeatureFlagsDTO>('/promotions/api/v1/feature-flags').pipe(
      tap((features) => (this.promotionFeatureFlags = features)),
      catchError((error) => {
        console.error('Error loading promotion feature flags', error);
        return of();
      })
    );
  }

  isPromotionFeatureEnabled(feature: PromotionFeatureFlagKeys): boolean {
    return isDefined(this.promotionFeatureFlags) && this.promotionFeatureFlags[feature];
  }
}
